export enum IntegrationSource {
  Redo = "redo",
  Malomo = "malomo",
}
